export const facilitator = {
  dashboard: {
    title: "Facilitator Dashboard",
    welcome: "Welcome back! Manage your workshop assignments, availability, and connect with your community.",
    tabs: {
      needsResponse: "Needs Response",
      assignedWorkshops: "My Assigned Workshops",
      generalAvailability: "General Availability",
      calendarView: "Calendar View",
      bulletinBoard: "Bulletin Board",
      resources: "Resources",
      workshopMaps: "Workshop maps",
    },
    workshopMaps: {
      moderationTitle: "Moderate map content",
      moderationHelp:
        "Review recordings made on the workshop maps you created. Set a content rating to clear an item.",
      moderationEmpty: "No recordings from your workshop maps are waiting for a content rating.",
      moderationLoading: "Loading recordings to moderate…",
      loadFailed: "Could not load workshop map recordings.",
      deleteTitle: "Delete recording",
      deleteMessage: "Delete this recording from the workshop map? This cannot be undone.",
      sessionName: "Map: {{name}}",
      needsReview: "Needs review",
    },
    resources: {
      organisation: "Organisation",
      projectHint:
        "Project documents appear here once you have been sent that project's contract.",
      emptyProject:
        "No project documents yet. They appear after you are sent a contract for a linked project.",
      linkProject: "Linked project",
      linkProjectHint:
        "Leave blank to share with every facilitator. If you pick a project, only facilitators who have been sent that project's contract will see this.",
      externalLinkUrl: "Link URL",
      externalLinkHint:
        "Paste any web link — Google Drive, Notion, Dropbox, a website, and so on. It does not need to be in Organisation Files.",
      externalLinkInvalid: "Enter a valid http or https link.",
    },
    workshops: {
      needsResponse: "Workshops Requiring Your Response",
      assigned: "My Assigned Workshops",
      responses: "My Responses",
      past: "Past Workshops",
      emptyMessages: {
        needsResponse: "No workshops need your response at this time.",
        assigned: "No workshops are currently assigned to you.",
        responses: "You haven't responded to any workshops yet.",
        past: "You haven't completed any workshops yet."
      }
    },
    contactInfo: {
      leadContact: "Lead Contact",
      additionalContacts: "Additional Contacts",
      noRole: "No role specified",
      contactDetails: "Contact Information"
    }
  },
  compliance: {
    errors: {
      userNotFound: "User information not found",
      loadInfoFailed: "Failed to load facilitator information"
    }
  }
}
